import React from 'react'

export default function Heart() {
    return <div className='bubble-heart'>
        <img alt="heart" className='bubble-icon-beat' src={process.env.PUBLIC_URL + "/img/heart.png"} width={30}/>
    </div>
}